import { render, staticRenderFns } from "./OperaBookTextWindow.vue?vue&type=template&id=0b92a4eb&"
import script from "./OperaBookTextWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBookTextWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports